import { render, staticRenderFns } from "./CreateProject.yaml?vue&type=template&id=c3909b1a&component"
import script from "./CreateProject.yaml?vue&type=script&lang=ts&component"
export * from "./CreateProject.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports